import { remove } from "unist-util-remove";
function isLiteral(node) {
    return "value" in node;
}
function isMdxjsEsm(node) {
    return node.type === "mdxjsEsm";
}
export function clsx(arr) {
    return arr.filter((item) => !!item);
}
const RemarkMdxRemoveEsm = (options) => {
    if (typeof options === "undefined")
        return removeAllEsm();
    if (typeof options === "string") {
        if (options === "export")
            return removeExports();
        else if (options === "import")
            return removeImports();
    }
    if (Array.isArray(options)) {
        if (options.includes("import") && options.includes("export")) {
            return removeAllEsm();
        }
        else if (options.includes("export")) {
            return removeExports();
        }
        else if (options.includes("import")) {
            return removeImports();
        }
    }
    function removeAllEsm() {
        return (tree) => {
            remove(tree, "mdxjsEsm");
        };
    }
    function removeExports() {
        return (tree) => {
            remove(tree, (node) => {
                // type predicate
                if (!isLiteral(node))
                    return;
                // type predicate
                if (!isMdxjsEsm(node))
                    return;
                const type = node.data?.estree?.body[0].type;
                return (type === "ExportNamedDeclaration" ||
                    type === "ExportDefaultDeclaration" ||
                    type === "ExportAllDeclaration");
            });
        };
    }
    function removeImports() {
        return (tree) => {
            // remove import declarations
            remove(tree, (node) => {
                // type predicate
                if (!isLiteral(node))
                    return;
                // type predicate
                if (!isMdxjsEsm(node))
                    return;
                const type = node.data?.estree?.body[0].type;
                return type === "ImportDeclaration";
            });
        };
    }
    return;
};
export default RemarkMdxRemoveEsm;
//# sourceMappingURL=index.js.map